export default "__VITE_ASSET__DNI_vgsr__"